module.exports = __webpack_public_path__ + "static/media/heist-player-login-bg.6640acec.jpg";